import { ITriggerOrderDto } from '../interfaces';

/**
 * Only the steps array is needed to walk the trigger indexes, so any checkpoint
 * shape works here (input DTOs, output DTOs, schemas).
 */
export const getNextCheckpointAndStepIndex = (
    triggerOrder: ITriggerOrderDto[],
    checkpoints: { steps?: object[] }[],
): { checkpointIndex: number | null; stepIndex: number | null } => {
    const { checkpointIndex: currentCheckpointIndex, stepIndex: currentStepIndex } =
        triggerOrder[triggerOrder.length - 1];

    const hasNextStepAtCurrentCheckpoint =
        checkpoints[currentCheckpointIndex]?.steps?.[currentStepIndex + 1] !== undefined;

    // If you can advance in the current checkpoint
    if (hasNextStepAtCurrentCheckpoint)
        return {
            checkpointIndex: currentCheckpointIndex,
            stepIndex: currentStepIndex + 1,
        };

    const hasNextCheckpoint = checkpoints[currentCheckpointIndex + 1] !== undefined;
    const isAtFinalStepAtFinalCheckpoint = !hasNextStepAtCurrentCheckpoint && !hasNextCheckpoint;
    // No steps and checkpoints to progress, I am at the end
    if (isAtFinalStepAtFinalCheckpoint) {
        return { checkpointIndex: null, stepIndex: null };
    }

    const hasCheckpointAvailableToContinue = !hasNextStepAtCurrentCheckpoint && hasNextCheckpoint;
    // Without the next step in the current checkpoint, but with at least one step in the next checkpoint.
    if (hasCheckpointAvailableToContinue) {
        return { checkpointIndex: currentCheckpointIndex + 1, stepIndex: 0 };
    }

    return { checkpointIndex: null, stepIndex: null };
};
